import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_ENVIRONMENT } from '../../app-environment.token';
import { CMS_TOKEN } from '../../common/cms/cms-token.interceptor';
import { AbstractFetchAdaptor } from '../../common/fetch/abstract-fetch.adaptor';

export interface CMSResourceProps {
  slug: string;
}

export interface CMSResourceResponse {}

@Injectable()
export class CMSResourceFetchAdaptor extends AbstractFetchAdaptor<CMSResourceProps, CMSResourceResponse> {
  name = 'cms-resource';

  private appEnv = inject(APP_ENVIRONMENT);
  private http = inject(HttpClient);

  onRequest(props: CMSResourceProps): Observable<CMSResourceResponse> {
    return this.http.get(this.appEnv.cmsApiURL + `/resources/${props.slug}/pages?page=1&per_page=-1`, {
      context: new HttpContext().set(CMS_TOKEN, this.appEnv.cmsToken),
    });
  }
}
